import React, { useState } from "react";
import { Input, Button, Alert, Card, Table } from "antd";
import { useHistory } from "react-router-dom";
import "antd/dist/reset.css";

const Tracking = () => {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [trackingSuccess, setTrackingSuccess] = useState(false);
  const [trackingError, setTrackingError] = useState(false);
  const history = useHistory();

  const handleInputChange = (e) => {
    setTrackingNumber(e.target.value);
    setTrackingError(false);
  };

  const handleTrackingSubmit = () => {
    if (!trackingNumber.trim()) {
      setTrackingError(true);
      return;
    }
    setTrackingSuccess(true);
    setTrackingError(false);
  };

  const trackingDetails = {
    resi: "ILIEX0912819000",
    courier: "ILI EXPRESS",
    pelayanan: "EXPRESS CARGO",
    waktuPengiriman: "20 Jan, 11:57 pm",
    pengirim: "Ade, Mr. - Guangzhou, China",
    tujuan: "Imanuel, Mr - Medan, Sumatera Utara",
    statusTerakhir: [
      {
        tanggal: "12 Apr, 5:59 am",
        keterangan: "Out for delivery",
      },
    ],
  };

  const handleDetailClick = () => {
    history.push(`/tracking-detail?resi=${trackingDetails.resi}`);
  };

  const columns = [
    {
      title: "Date/Time",
      dataIndex: "tanggal",
      key: "tanggal",
      render: (text) => <span style={{ color: "#0050B3" }}>{text}</span>,
    },
    {
      title: "Description",
      dataIndex: "keterangan",
      key: "keterangan",
    },
    {
      title: "Action",
      key: "action",
      render: () => (
        <Button type="link" onClick={handleDetailClick}>
          Detail
        </Button>
      ),
    },
  ];

  return (
    <div className="col-lg-12">
      <Card
        title={
          <h5
            className="text-center"
            style={{ margin: 0, fontWeight: "bold", fontSize: "16px" }}
          >
            QUICK TRACKING
          </h5>
        }
        bordered={false}
        className="mb-4 shadow-sm"
      >
        <Input
          placeholder="Input Shipments by Number"
          value={trackingNumber}
          onChange={handleInputChange}
          style={{
            marginBottom: "10px",
            borderRadius: "6px",
            borderColor: trackingError ? "#FF4D4F" : "#D9D9D9",
          }}
        />
        {trackingError && (
          <Alert
            message="Nomor Resi Tidak Boleh Kosong!"
            type="error"
            showIcon
            style={{ marginBottom: "10px" }}
          />
        )}
        <Button
          type="primary"
          block
          onClick={handleTrackingSubmit}
          style={{
            backgroundColor: "#FFC107",
            borderColor: "#FFC107",
            color: "#000",
            fontWeight: "bold",
          }}
        >
          Find Your Package
        </Button>
      </Card>

      {trackingSuccess && (
        <Card bordered={false} className="shadow-sm">
          <div className="row">
            <div className="col-lg-3">
              <b>Shipment Number :</b> <br />
              {trackingDetails.resi}
            </div>
            <div className="col-lg-3">
              <b>Courier :</b> <br />
              {trackingDetails.courier}
            </div>
            <div className="col-lg-3">
              <b>Service :</b> <br />
              {trackingDetails.pelayanan}
            </div>
            <div className="col-lg-3">
              <b>Delivery at :</b> <br />
              {trackingDetails.waktuPengiriman}
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-lg-6">
              <b>From :</b> <br />
              {trackingDetails.pengirim}
            </div>
            <div className="col-lg-6">
              <b>To :</b> <br />
              {trackingDetails.tujuan}
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-lg-12">
              <Table
                columns={columns}
                dataSource={trackingDetails.statusTerakhir}
                pagination={false}
                bordered
                rowKey={(record) => record.tanggal}
              />
            </div>
          </div>
        </Card>
      )}
    </div>
  );
};

export default Tracking;
